import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { Spin } from "antd";
import SkeletonTable from "../../../components/table/SkeletonTable";
import ViewFilesModal from "../../files/components/ViewFilesModal";
import {
  GetFileAnswerApi,
  GetFileDetailsApi,
} from "../../../api/request/service";
import BackButton from "../../../components/button/BackButton";

const ViewFileData = () => {
  const { id } = useParams();
  const [fileData, setFileData] = useState(null);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFilesOpen, setIsFilesOpen] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState({});

  const defaultRender = (value) => (value ? value : "--");

  const columns = [
    {
      title: "Question",
      dataIndex: "field_label",
      render: defaultRender,
    },
    {
      title: "Answer",
      dataIndex: "response_text",
      render: defaultRender,
      width: 250,
      fixed: "right",
    },
  ];

  const getAnswer = async () => {
    try {
      setIsLoading(true);
      let params = { file_id: id };
      const { data } = await GetFileAnswerApi(params);
      if (data?.status) {
        setData(
          data?.data?.map((section) => {
            return {
              ...section,
              questions: section?.questions?.map((question) => {
                return {
                  ...question,
                  response_text: (
                    <p className="text-wrap">{question?.response_text}</p>
                  ),
                  ...(question?.documents?.length && {
                    response_text: (
                      <a
                        className="text-blue-500"
                        onClick={() => {
                          setSelectedQuestion(question);
                          setIsFilesOpen(true);
                        }}
                      >
                        View Files
                      </a>
                    ),
                  }),
                };
              }),
            };
          })
        );
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const getFileDetails = async () => {
    try {
      setIsLoading(true);
      const params = { file_id: id };
      const { data } = await GetFileDetailsApi(params);
      if (data?.status) setFileData(data?.data);
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getFileDetails();
      getAnswer();
    }
  }, [id]);

  return (
    <>
      <div className="bg-white border rounded-xl p-5">
        <div className="flex justify-between gap-5 mb-5">
          <div className="flex items-center gap-3">
            <BackButton />
            <h2 className="title capitalize">{fileData?.service_name_slug}</h2>
          </div>
        </div>

        {isLoading ? (
          <div className="flex justify-center flex-col mt-[20%]">
            <Spin size="large" />
            <p className="primary text-center mt-2">Loading...</p>
          </div>
        ) : (
          <>
            {data?.length ? (
              <>
                {data?.map((item, index) => (
                  <div className="table-radius-0 text-light mb-10">
                    <p className="title text-primary mb-5">
                      {`Section ${index + 1}:`} {item?.section_name}
                    </p>
                    <SkeletonTable
                      columns={columns}
                      data={item?.questions}
                      isLoading={isLoading}
                    />
                  </div>
                ))}
              </>
            ) : null}
          </>
        )}
      </div>

      {/* View Files */}
      <ViewFilesModal
        isOpen={isFilesOpen}
        setIsOpen={setIsFilesOpen}
        question={selectedQuestion}
      />
    </>
  );
};

export default ViewFileData;
